import { ButtonIcon, styled } from 'shared/Houston';

export const ChevronDownButton = styled(ButtonIcon)`
  && {
    width: 24px;
    height: 24px;
    margin-right: ${({ theme }) => theme.spacing.nano};
  }
`;
